<div class="flex h-full w-full flex-col">
  <app-toolbox
    [sections]="toolboxSections()"
    [searchConfig]="searchCfg"
    [searchPlaceholder]="searchPlaceholder()"
    [(searchQuery)]="search" />

  <div class="flex min-h-0 w-full flex-1 flex-col p-3">
    <app-plan-edit-bar class="mb-3 empty:hidden" [planId]="planId()" />
    @if (availableEntities().length === 0) {
      <div class="flex flex-col items-center justify-center px-6 py-16 text-center">
        <div class="max-w-sm">
          <div
            class="bg-accent-interactive mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full">
            <i [class]="ICONS.stack" class="text-accent-main text-3xl"></i>
          </div>
          <h3 class="mb-2">{{ 'features.entities.no_data' | translate }}</h3>
          <p class="text-text-secondary text-sm">
            {{ 'features.entities.no_data_description' | translate }}
          </p>
        </div>
      </div>
    } @else if (cards().length === 0) {
      <div class="flex flex-col items-center justify-center px-6 py-16 text-center">
        <div class="max-w-sm">
          <div
            class="bg-accent-interactive mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full">
            <i [class]="ICONS.magnifyingGlass" class="text-accent-main text-3xl"></i>
          </div>
          <h3 class="mb-2">{{ 'features.entities.no_search_results' | translate }}</h3>
          <p class="text-text-secondary text-sm">
            {{ 'features.entities.no_search_results_description' | translate }}
          </p>
        </div>
      </div>
    } @else {
      <app-cards-list
        class="flex min-h-0 w-full flex-1 flex-col overflow-y-auto"
        [config]="cardListConfig()"></app-cards-list>
    }
  </div>
</div>
